export const pricingSections = [
    {
        name: "Features",
        features: [
            {
                name: "Organic Follower Growth: Gain real, engaged followers through genuine interactions and personalized strategies, helping you build a loyal community.",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Content Optimization: Receive tailored content recommendations to enhance your feed's visual appeal and captivate your target audience.",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Hashtag Research: Unlock the potential of strategic hashtags to boost your posts' discoverability and increase your reach.",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Community Engagement: Our team proactively engages with your followers, responding to comments, and fostering genuine connections on your behalf.",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Monthly Progress Report: Stay updated on your Instagram growth journey with a comprehensive monthly progress report, showcasing key metrics and insights.",
                tiers: { Premium: true, Business: true },
            },
            {
                name: "Customized Strategy: Receive a tailor-made growth strategy designed specifically for your niche and target audience.",
                tiers: { Premium: true, Business: true },
            },
            {
                name: "Influencer Outreach: Tap into our network of influencers for collaborations and shout-outs to gain exposure to a broader audience.",
                tiers: { Premium: true, Business: true },
            },
            {
                name: "Story Management: Maximize the potential of Instagram Stories with engaging content and highlights to captivate your followers.",
                tiers: { Premium: true, Business: true },
            },
            {
                name: "Competitor Analysis: Gain insights into your competitors' performance to identify opportunities and stay ahead of the curve.",
                tiers: { Premium: true, Business: true },
            }
        ],
    },
    {
        name: "Reporting",
        features: [
            {
                name: "Follower Growth Analysis: Track your follower count's organic growth over time to understand the impact of our strategies.",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Engagement Metrics: Get detailed statistics on likes, comments, and interactions to gauge your content's effectiveness..",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Audience Insights: Understand your audience demographics, interests, and behavior to fine-tune your content strategy.",
                tiers: { Premium: true, Business: true }
            },
            {
                name: "Post Optimization Suggestions: Receive recommendations for optimizing your post timings and content to maximize engagement.",
                tiers: { Business: true }
            }
        ],
    },
    {
        name: "Support",
        features: [
            {
                name: "24/7 Email Support: Reach out to us anytime, and our dedicated support team will respond promptly to address your queries and concerns.",
                tiers: { Standard: true, Premium: true, Business: true },
            },
            {
                name: "Priority Queue: As a Standard plan member, your inquiries receive priority handling for faster resolutions.",
                tiers: { Premium: true, Business: true }
            },
            {
                name: "Priority Growth Campaigns: Participate in priority growth campaigns and strategic collaborations with other businesses to accelerate your growth.",
                tiers: { Premium: true, Business: true },
            },
            {
                name: "Advanced Content Strategy: Unlock a comprehensive content strategy tailored to your brand's voice and objectives, ensuring consistent and impactful messaging.",
                tiers: { Business: true },
            },
            {
                name: "Influencer Management: Utilize our expertise in influencer management to build strong partnerships and maximize your brand's exposure.",
                tiers: { Business: true },
            },
            {
                name: "Exclusive Early Access: Get exclusive early access to new features and updates before they're rolled out to other plans.",
                tiers: { Business: true },
            },
        ],
    },
];
